// Hash-based router: routes = [{path: '/coach/weeks', match: /^\/coach\/weeks\/?$/, handler}]
// Path params like /coach/weeks/:id → compiled to regex with named groups.

const routes = [];
let notFound = null;
let outletEl = null;

export function registerRoute(pattern, handler) {
  const paramNames = [];
  const regex = new RegExp('^' + pattern.replace(/:([a-zA-Z0-9_]+)/g, (_, name) => {
    paramNames.push(name);
    return '([^/]+)';
  }).replace(/\//g, '\\/') + '\\/?$');
  routes.push({ pattern, regex, paramNames, handler });
}

export function setNotFound(fn) { notFound = fn; }

export function setOutlet(el) { outletEl = el; }

export function currentPath() {
  const h = location.hash || '#/';
  return h.slice(1) || '/';
}

export function navigate(path, { replace = false } = {}) {
  const target = '#' + path;
  if (replace) location.replace(target);
  else location.hash = target;
}

export async function dispatch() {
  const path = currentPath();
  const [pathOnly, queryStr] = path.split('?');
  const query = Object.fromEntries(new URLSearchParams(queryStr || ''));
  for (const r of routes) {
    const m = r.regex.exec(pathOnly);
    if (m) {
      const params = {};
      r.paramNames.forEach((n, i) => (params[n] = decodeURIComponent(m[i + 1])));
      try {
        await r.handler({ outlet: outletEl, params, query, path });
      } catch (err) {
        console.error('Route handler failed:', err);
        if (outletEl) {
          outletEl.replaceChildren();
          outletEl.appendChild(errorNode(err));
        }
      }
      return;
    }
  }
  if (notFound) await notFound({ outlet: outletEl });
  else outletEl && (outletEl.textContent = 'Sayfa bulunamadı.');
}

function errorNode(err) {
  const el = document.createElement('div');
  el.className = 'card';
  el.innerHTML = `<h3>Bir şeyler ters gitti</h3><p class="muted" style="margin-top:8px">${err.message || 'Bilinmeyen hata.'}</p>`;
  return el;
}

export function initRouter() {
  window.addEventListener('hashchange', dispatch);
  window.addEventListener('load', dispatch);
  if (document.readyState !== 'loading') dispatch();
}
